import Repository from "@shared/services/api/abstracts/Repository";
import { PublicEventReviewSerializer } from "@app-contexts/public/features/event-detail/data/types/events";

export default class PublicVenueRatingsRepository extends Repository<PublicEventReviewSerializer> {
  public readonly repositoryName = "PublicVenueRatingsRepository";

  public readonly endpoint = "api/public/venues/{venueId}/ratings/";
}
